import { LoadableAfterPaint } from '@confluence/loadable';

export const CreateWithRovoExperience = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateWithRovoExperience" */ '../src/CreateWithRovoExperience.tsx'
			)
		).CreateWithRovoExperience,
});
